import axios from "axios";
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL = `${config?.URL_INVOICES}`;

const request = async (method, endpoint, data = null, params = null) => {
  const url = `${BASE_URL}${endpoint}`;
  try {
    const headers = await headers_get();
    return await axios({ method, url, data, params, headers });
  } catch (error) {
    console.error(`Error in ${method.toUpperCase()} ${url}:`, error?.response?.data || error.message);
    throw error;
  }
};

export const invoice_payment_get = async (fi, ff, rfc, sdn) => {
  return request("get", "/od/invoices/payment", null, {
    di: fi,
    df: ff,
    rfc: rfc ?? null,
    name: sdn ?? null,
  });
};

export const invoice_payment_post = async (dta) =>
  await request("post", `/od/invoices/payment`, dta);

export const detail_invoice_get = async (id, params) => {
  return request("get", `/od/invoices/${id}`, null, params);
};

export const calculate_invoice_get = async (dta) =>
  await request("post", `/od/concepts/calculate`, dta);

export const related_invoice_get = async (id) => {
  return request("get", `/od/invoices/${id}/related`,);
};

export const generate_invoice_post = async (dta) =>
  await request("post", `/od/invoices`, dta);

export const status_invoice = async (id, uuid) => {
  return request("get", `/od/invoices/${id}/cancel`, null, {
    uuid: uuid,
  },);
};

export const concept_invoice_get = async () => { return request("get", `/od/concepts`); };

// 🔹 Catálogos SAT
export const sat_catalogue_prodServ_get = async () => await request("get", "/od/sat_catalogue/prod_serv");
export const sat_catalogue_units_get = async () => await request("get", "/od/sat_catalogue/units");

// 🔹 Series
export const series_get = async (type) => await request("get", "/od/series", null, { type });

// 🔹 Detalles de facturas
export const invoices_detail_get = async (id, c_type) => await request("get", `/od/invoices/${id}`, null, { c_tipodecomprobante: c_type });

// 🔹 Descargar factura
export const download_invoice_get = async (typedocumentexmlorpdf, fileName_document, id) =>
  await request("get", `/od/invoices/${id}/download`, null, {
    filename: fileName_document,
    document_type: typedocumentexmlorpdf,
  });

// 🔹 Facturas relacionadas
export const invoice_related_get = async (id) => await request("get", `/od/invoices/${id}/related`);

// 🔹 Enviar factura (sin UUID en la nueva actualización)
export const send_invoice_post = async (id, uuid, email) =>
  await request("post", `/od/invoices/${id}/send_email`, { uuid, email });

// 🔹 Obtener estado de factura
export const get_status = async (id, uuid) =>
  await request("get", `/od/invoices/${id}/cancel`, null, { uuid });




export const cancel_invoice_method_version_2 = async (id, dta) =>
  await request("post", `/od/invoices/${id}/cancel`, dta);


export const cancel_invoice_sat_method_version_2 = async (id, dta) =>
  await request("post", `/od/invoices/${id}/cancel/sat`, dta);

